/* tslint:disable */
/* eslint-disable */
/**
 * Subscription App API
 * Provides management of all subscription operations at subscription app tier.
 *
 * The version of the OpenAPI document: 1.11.12
 * Contact: Pankaj.Gautam@Amway.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * MANUAL, AUTOMATIC
 * @export
 */
export const SubscriptionType = {
    Manual: 'MANUAL',
    Automatic: 'AUTOMATIC'
} as const;
export type SubscriptionType = typeof SubscriptionType[keyof typeof SubscriptionType];


export function SubscriptionTypeFromJSON(json: any): SubscriptionType {
    return SubscriptionTypeFromJSONTyped(json, false);
}

export function SubscriptionTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubscriptionType {
    return json as SubscriptionType;
}

export function SubscriptionTypeToJSON(value?: SubscriptionType | null): any {
    return value as any;
}

